import React,{Component} from 'react';
import { Modal } from 'react-bootstrap';
import {Button} from "shards-react";


export default class ViewExam extends Component {
  render(){
  return (
    <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Subject Name
                  </th>
                  
                  <th scope="col" className="border-0">
                     Passing Marks
                  </th>
                  <th scope="col" className="border-0">
                      Maximum Marks
                  </th>
                  
                </tr>
              </thead>
             <tbody>
                     {
                    this.props.subjects.map((item,i)=>{
                      return <TRow  data={item} 
                                    key={i} 
                                    index={i+1}
                                    />
                    })
                  }
              </tbody>
            </table>

        </Modal.Body>
        <Modal.Footer>
          <Button   theme="info" onClick={this.props.handleClose}>
            OK
          </Button>
         
        </Modal.Footer>
      </Modal>
    );
  }
}



class TRow extends Component{
  render(){
    return(
      <tr>
        <td>{this.props.index}</td>
        <td>{this.props.data.subjectname}</td>
        <td>{this.props.data.passing}</td>
        <td>{this.props.data.total}</td>  
      </tr>

    )
  }
}